/* eslint-disable no-param-reassign */
import m from "mithril";
import moment from "moment";
import header from "../../components/header";
import toolbar from "../../components/toolbar"
import sidebar from "../../components/sidebar"
import table_data from "../../components/table_data"
import graph from "./components/graph";
import multiSelect from "../../components/bootstrap-select";
import companyBannner from "../../components/companyBannner";
import { runQuery, headers } from "../../utils/fetchData";
import timePicker from "../../components/timePicker";
import htmlEditor from "../../components/htmlEditor";
import config from "../../config";
import stats from "./components/stats";
import map from "./components/google-maps";
import tmpMap from "./components/tmpMap";
import tutorials from "./components/tutorials";
import commonQuestions from "./components/commonQuestions";
import dataMap from "../../utils/data";

import { t } from '../../translation-files/translator'
import footer from "../../components/footer";

import addTopUpModal from "./modals/selectCard"
import topUpOptions from "./modals/topUpOptions"

function getNumberWithOrdinal(i) {
  const j = i % 10;

  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return "rd";
  }
  return `${i}th`;
}

export default {
  async oninit({ state, attrs }) {
    Object.assign(state, {
      selectedTeams: [],
      selectedUsers: [],
      selectedProjects: [],
      teams: [],
      users: [],
      projects: [],
      projectsT: true,
      teamsT: false,
      usersT: false,
      fetching: false,
      selectedTime: {
        end: moment(new Date()),
        start: moment(new Date())
          .subtract(6, "day")
          .startOf("day")
      },
      data: [],
      labels: [],
      stats: {},
      gpsData: []
    });

    state.fetchResults = async clientId => {
      const { start, end } = state.selectedTime;

      state.fetching = true;
      m.redraw();

      try {
        const results = await m.request({
          method: "POST",
          headers: headers(),
          url: `${config[window.env].apiUrl}/submision/breakDayDown/${new Date(
            start
          ).toISOString()}/${new Date(end).toISOString()}`,
          data: Object.assign(
            {
              client: clientId
            },
            state.teamsT === true
              ? { teamId: { $in: state.selectedTeams } }
              : {},
            state.projectsT === true
              ? { projectId: { $in: state.selectedProjects } }
              : {},
            state.usersT === true
              ? { userId: { $in: state.selectedUsers } }
              : {}
          )
        });

        Object.assign(state, {
          fetching: false,
          data: [],
          labels: []
        });
        m.redraw();

        const labels = Object.values(results)
          .reverse()
          .map(
            ({ start }) =>
              `${getNumberWithOrdinal(moment(start).format("DD"))}-${moment(
                start
              ).format("MM")}`
          );

        const data = Object.values(results)
          .reverse()
          .map(({ count }) => count);

        const gpsData = Object.values(results)
          .reverse()
          .map(({ data }) => data);

        Object.assign(state, {
          data,
          labels,
          gpsData
        });

        m.redraw();
      } catch (err) {
        Object.assign(state, {
          fetching: false
        });
        m.redraw();
      }
    };

    state.resetSelections = () => {
      Object.assign(state, {
        selectedTeams: [],
        selectedUsers: [],
        selectedProjects: [],
        teams: [],
        users: [],
        projects: [],
        projectsT: true,
        teamsT: false,
        usersT: false,
        selectedTime: {
          end: moment(new Date()),
          start: moment(new Date())
            .subtract(6, "day")
            .startOf("day")
        },
        fetching: false,
        data: [],
        labels: []
      });

      m.redraw();
    };

    const {
      users,
      id: clientId,
      stats,
      teams,
      projects
    } = await dataMap.getClientData();

    Object.assign(state, {
      projects,
      teams,
      users,
      stats,
      clientId,
      selectedTeams: [...teams.map(p => p.id)],
      selectedUsers: [...users.map(p => p.id)],
      selectedProjects: [...projects.map(p => p.id)]
    });

    state.fetchResults(clientId);
    m.redraw();
  },
  // disable due to failures on some browsers
  oncreate() {
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const accType = urlParams.get('u');
    //   if (accType === 'new')
    //     introJs().start();
  },
  view({ state, attrs }) {
    console.log({ t: t() })
    return [
      // <!--begin::Header-->
      m(header, {
        logos: {
                  dark: "assets/media/logos/rubis-logo-white.svg",
          light: "assets/media/logos/rubis-logo-white.png"
        },
        links: [{
          label: t().home_acc_info.navbar.reports,
          route: "/reports",
        }, {
          label: t().home_acc_info.navbar.user_management,
          route: "/userManagement"
        }, {
          label: t().home_acc_info.navbar.support,
          route: "/support"
        }, {
          label: t().home_acc_info.navbar.notifications,
          route: "/notifications"
        }, {
          label: t().home_acc_info.navbar.trends,
          route: "/trends-disabled"
        }]
      }),
      // <!--end::Header-->

      // <!--begin::Wrapper-->
      m("div", { "class": "app-wrapper flex-column flex-row-fluid", "id": "kt_app_wrapper" }, [
        // <!--begin::Main-->
        m("div", { "class": "app-main flex-column flex-row-fluid", "id": "kt_app_main" }, [
          // <!--begin::Content wrapper-->
          m("div", { "class": "d-flex flex-column flex-column-fluid" }, [
            // <!--begin::Toolbar-->
            m(toolbar, {
              header: {
                label: "XYZ Transporters",
                subLabel: [t().common.account_type, t().common.post_paid]
              },
              toolBarItems: [{
                label: t().home_acc_info.subheader_labels.dashboard,
                route: "/dashboard",
                routesToActivate:["/dashboard"]
              }, {
                label: t().home_acc_info.subheader_labels.home,
                route: "/",
                routesToActivate:["/","/stationFinder","/journeyPlan"]
              }, {
                label: t().home_acc_info.subheader_labels.cards,
                route: "/cardList",
                routesToActivate:["/cardList","/departments","/drivers"]
              }, {
                label: t().home_acc_info.subheader_labels.transactions,
                route: "/transactions",
                routesToActivate:["/transactions"]
              }, {
                label: t().home_acc_info.subheader_labels.funds,
                route: "/funds",
                routesToActivate:["/funds","/cardToCard"]
              }]
            }),
            // <!--end::Toolbar-->

            // <!--begin::Content-->
            m("div", { "class": "app-container container-xxl", "id": "kt_app_content_container" }, [
              // <!--begin::Inbox App - Messages -->
              m("div", { "class": "d-flex flex-column flex-lg-row" }, [
                // <!--begin::Sidebar-->
                m(sidebar, {
                  sideBarItems: [{
                    label: t().card_to_card.sidebar_labels.top_up,
                    icon: "bi bi-book",
                    svg:`<svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6023 16.636C10.7302 16.7128 10.8671 16.7468 11 16.7451C11.1329 16.7468 11.2698 16.7128 11.3977 16.636L12.533 15.9549C14.7595 14.619 17.4825 14.4008 19.8933 15.3651C20.7826 15.7208 21.75 15.0659 21.75 14.1081V2.44918C21.75 1.87123 21.3981 1.35151 20.8615 1.13686C17.7564 -0.105172 14.2492 0.175851 11.3815 1.89647L11 2.12539L10.6185 1.89647C7.75077 0.175851 4.24357 -0.105172 1.13848 1.13686C0.60187 1.35151 0.25 1.87123 0.25 2.44918V14.1081C0.25 15.0659 1.21739 15.7208 2.10672 15.3651C4.51752 14.4008 7.24052 14.619 9.46701 15.9549L10.6023 16.636ZM1.75 2.50801V13.8948C4.54579 12.8468 7.67179 13.1285 10.2388 14.6686L10.25 14.6754V3.42467L9.84673 3.18271C7.39774 1.71332 4.40634 1.46498 1.75 2.50801ZM11.7612 14.6686L11.75 14.6754V3.42467L12.1533 3.18271C14.6023 1.71332 17.5937 1.46498 20.25 2.50801V13.8948C17.4542 12.8468 14.3282 13.1285 11.7612 14.6686Z" fill="black"/>
                    <path d="M8.27516 17.0423C6.2513 15.8617 3.7487 15.8617 1.72484 17.0423L1.6221 17.1022C1.26431 17.3109 1.14346 17.7701 1.35217 18.1279C1.56088 18.4857 2.02011 18.6066 2.3779 18.3979L2.48065 18.3379C4.03746 17.4298 5.96254 17.4298 7.51935 18.3379L8.60661 18.9722C10.0856 19.8349 11.9144 19.8349 13.3934 18.9722L14.4806 18.3379C16.0375 17.4298 17.9625 17.4298 19.5194 18.3379L19.6221 18.3979C19.9799 18.6066 20.4391 18.4857 20.6478 18.1279C20.8565 17.7701 20.7357 17.3109 20.3779 17.1022L20.2752 17.0423C18.2513 15.8617 15.7487 15.8617 13.7248 17.0423L12.6376 17.6765C11.6257 18.2668 10.3743 18.2668 9.36242 17.6765L8.27516 17.0423Z" fill="black"/>
                    </svg>`,
                    route: "/funds"
                  },
                  {
                    label: t().card_to_card.sidebar_labels.card_to_card,
                    icon: "bi bi-book",
                    svg:`<svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6023 16.636C10.7302 16.7128 10.8671 16.7468 11 16.7451C11.1329 16.7468 11.2698 16.7128 11.3977 16.636L12.533 15.9549C14.7595 14.619 17.4825 14.4008 19.8933 15.3651C20.7826 15.7208 21.75 15.0659 21.75 14.1081V2.44918C21.75 1.87123 21.3981 1.35151 20.8615 1.13686C17.7564 -0.105172 14.2492 0.175851 11.3815 1.89647L11 2.12539L10.6185 1.89647C7.75077 0.175851 4.24357 -0.105172 1.13848 1.13686C0.60187 1.35151 0.25 1.87123 0.25 2.44918V14.1081C0.25 15.0659 1.21739 15.7208 2.10672 15.3651C4.51752 14.4008 7.24052 14.619 9.46701 15.9549L10.6023 16.636ZM1.75 2.50801V13.8948C4.54579 12.8468 7.67179 13.1285 10.2388 14.6686L10.25 14.6754V3.42467L9.84673 3.18271C7.39774 1.71332 4.40634 1.46498 1.75 2.50801ZM11.7612 14.6686L11.75 14.6754V3.42467L12.1533 3.18271C14.6023 1.71332 17.5937 1.46498 20.25 2.50801V13.8948C17.4542 12.8468 14.3282 13.1285 11.7612 14.6686Z" fill="black"/>
                    <path d="M8.27516 17.0423C6.2513 15.8617 3.7487 15.8617 1.72484 17.0423L1.6221 17.1022C1.26431 17.3109 1.14346 17.7701 1.35217 18.1279C1.56088 18.4857 2.02011 18.6066 2.3779 18.3979L2.48065 18.3379C4.03746 17.4298 5.96254 17.4298 7.51935 18.3379L8.60661 18.9722C10.0856 19.8349 11.9144 19.8349 13.3934 18.9722L14.4806 18.3379C16.0375 17.4298 17.9625 17.4298 19.5194 18.3379L19.6221 18.3979C19.9799 18.6066 20.4391 18.4857 20.6478 18.1279C20.8565 17.7701 20.7357 17.3109 20.3779 17.1022L20.2752 17.0423C18.2513 15.8617 15.7487 15.8617 13.7248 17.0423L12.6376 17.6765C11.6257 18.2668 10.3743 18.2668 9.36242 17.6765L8.27516 17.0423Z" fill="black"/>
                    </svg>`,
                    route: "/cardToCard"
                  }]
                }),
                // <!--end::Sidebar-->
                // <!--begin::Content-->
                m("div", { "class": "app-content", "id": "kt_app_content", style: {
                  "flex-grow": 1,
                  "flex-basis": "auto",
                } },
                  m("div", { "class": "app-container container-xxl", "id": "kt_app_content_container" },
                    [
                      m(addTopUpModal),
                      m(topUpOptions),
                      m(table_data, {
                        title: t().funds.title,
                        actionItems: [
                          m("div", { "class": "d-flex justify-content-end", "data-kt-customer-table-toolbar": "base", style: { "padding-right": "10px" } },
                            [
                              m("button", { "class": "btn btn-primary", "type": "button", "data-bs-toggle": "modal", "data-bs-target": "#kt_modal_add_customer" },
                                "Advanced Search"
                              )
                            ]
                          ),
                          m("div", { "class": "d-flex justify-content-end", "data-kt-customer-table-toolbar": "base", style: { "padding-right": "10px" } },
                            [
                              m("button", { "class": "btn btn-primary", "type": "button", "data-bs-toggle": "modal", "data-bs-target": "#kt_modal_add_customer", onclick(){
                                addTopUpModal.show()
                              } },
                                "Add New Top up"
                              )
                            ]
                          ),
                        ],
                        dataConfigs: {
                          sourceEndpoint: "/transactions",
                          disableActions: true,
                          disableSelection: false,
                          actionItems: [{
                            label: t().journey_plan.table_action_items.download,
                          }, {
                            label: t().journey_plan.table_action_items.advanced_search,
                          }],
                          dataMapping: [{
                            label: t().funds.funds_table_labels.card_number,
                            data_key: "card_number"
                          }, {
                            label: t().funds.funds_table_labels.card_name,
                            data_key: "card_name"
                          }, {
                            label: t().funds.funds_table_labels.department,
                            data_key: "department"
                          }, {
                            label: t().funds.funds_table_labels.amount,
                            data_key: "amount"
                          }, {
                            label: t().funds.funds_table_labels.payment_method,
                            data_key: "payment_method"
                          }, {
                            label: t().funds.funds_table_labels.date,
                            data_key: "date"
                          }],
                          dataRows: Array.from({ length: 25 }, () => ({
                            card_number: `XXXX-XXXX-XXXX-${Math.floor(Math.random() * 9000) + 1000}`,
                            card_name: `Card Holder:${Math.floor(Math.random() * 10) + 1}`,
                            department: ["HR", "Marketing", "Sales", "IT"][Math.floor(Math.random() * 4)],
                            amount: Math.floor(Math.random() * 10000) + 1,
                            payment_method: ["Credit Card", "Debit Card", "Bank Transfer"][Math.floor(Math.random() * 3)],
                            date: moment(new Date()).format("YYYY-MM-DD")
                          }))
                        }
                      })
                    ]
                  )
                )
                // <!--end::Content-->
              ])
              // <!--end::Inbox App - Messages -->
            ])
            // <!--end::Content-->
          ]),
          m(footer)
        ])
      ])

    ];
  }
};
